<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :model="formdata" label-width="120px">
          <el-form-item label="当前使用模式:">
            <span class="decorate_name">{{formdata.decorate_name}}</span>
            <el-button type="text" @click="choosemodule">切换模式</el-button>
          </el-form-item>
          <el-form-item>
            <el-popover placement="bottom-start" width="172" trigger="click">
              <div class="qr_wrap">
                <img :src="formdata.shop_qrcode" alt/>
              </div>
              <el-button slot="reference" type="primary" size="small">浏览商城</el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
      <div class="Pattern_wrap" v-if="formdata.decorate == 1 || formdata.decorate == 2">
        <div class="Pattern_img ml-20">
          <div class="mb-20">模式示例</div>
          <img :src="showImg" alt srcset/>
        </div>
      </div>
    </div>
    <chooseModuleDialog
            :visible.sync="choosemoduledialog"
            v-if="choosemoduledialog"
            :modellist="modellist"
            :id="formdata.decorate"
            @choosemodelesucess="choosemodelesucess"
    ></chooseModuleDialog>
	<CustomizingATemplate
			v-if="formdata.decorate == 3"
	></CustomizingATemplate>
  </div>
</template>
<script>
  import chooseModuleDialog from "@/components/dialog/chooseModuleDialog.vue";
  import CustomizingATemplate from "@/views/CustomizingATemplate/index.vue";
  import api from "@/api.js";

  export default {
    name: "homeDecoration",
    components: {
      chooseModuleDialog,
	  CustomizingATemplate
    },
    data() {
      return {
        formdata: {
          decorate: "",
          decorate_name: "",
          shop_qrcode: ""
        },
        modellist: [],
        choosemoduledialog: false,
        showImg: ''
      };
    },
    created() {
      this.querydecoratetype();
    },
    methods: {
      // 查询当前模式
      querydecoratetype() {
        let params = {};
        this.axios
            .post(api.decorate_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.decorate = response.data.info.decorate;
                this.formdata.decorate_name = response.data.info.decorate_name;
                this.formdata.shop_qrcode = response.data.info.shop_qrcode; // 预览
                for (let i in response.data.list) {
                  if (response.data.list[i].id === response.data.info.decorate) {
                    this.showImg = response.data.list[i].pic
                  }
                }
                this.modellist = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 选择模板
      choosemodule() {
        this.choosemoduledialog = true;
      },
      // 选择模板回调
      choosemodelesucess() {
        this.querydecoratetype();
      }
    }
  };
</script>
